import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Paper, 
  Alert, 
  AlertTitle,
  useTheme
} from '@mui/material';
import AnnouncementIcon from '@mui/icons-material/Announcement';

const Announcement: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box 
      id="announcements" 
      sx={{ 
        py: 8,
        background: theme.palette.mode === 'dark' 
          ? 'linear-gradient(45deg, #303030 30%, #212121 90%)' 
          : 'linear-gradient(45deg, #f5f5f5 30%, #e0e0e0 90%)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography 
            variant="h3" 
            component="h2" 
            gutterBottom
            sx={{ fontWeight: 'bold' }}
          >
            Announcements
          </Typography>
          <Typography 
            variant="h6" 
            color="textSecondary" 
            sx={{ maxWidth: 700, mx: 'auto' }}
          >
            Stay updated with the latest news and changes about Web Starter.
          </Typography>
        </Box>
        
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 800,
            mx: 'auto',
            borderRadius: 2,
            background: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Alert 
            severity="info" 
            icon={<AnnouncementIcon fontSize="inherit" />}
            sx={{ 
              mb: 3, 
              alignItems: 'flex-start',
              '.MuiAlert-message': {
                width: '100%'
              }
            }}
          >
            <AlertTitle sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
              Payment Method Update
            </AlertTitle>
            <Typography variant="body1" paragraph>
              Starting from June 15, 2024, we will be discontinuing PayPal as an international payment method. Our platform is entering the Web3 era and will be using USDT tokens for payments going forward.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Posted on: April 24, 2025
            </Typography>
          </Alert>
          
          <Alert 
            severity="success" 
            icon={<AnnouncementIcon fontSize="inherit" />}
            sx={{ 
              mb: 3, 
              alignItems: 'flex-start',
              '.MuiAlert-message': {
                width: '100%'
              }
            }}
          >
            <AlertTitle sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
              New Version Released
            </AlertTitle>
            <Typography variant="body1" paragraph>
              We're excited to announce the release of Web Starter v2.5, featuring improved performance, enhanced cross-platform compatibility, and new packaging options.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Posted on: March 15, 2025
            </Typography>
          </Alert>
          
          <Alert 
            severity="warning" 
            icon={<AnnouncementIcon fontSize="inherit" />}
            sx={{ 
              alignItems: 'flex-start',
              '.MuiAlert-message': {
                width: '100%'
              }
            }}
          >
            <AlertTitle sx={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
              End of Support for Legacy Versions
            </AlertTitle>
            <Typography variant="body1" paragraph>
              Please note that support for Web Starter versions prior to v2.0 will end on July 1, 2025. We recommend upgrading to the latest version to continue receiving updates and support.
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Posted on: February 1, 2025
            </Typography>
          </Alert>
        </Paper>
      </Container>
    </Box>
  );
};

export default Announcement;
